
import * as THREE from 'three';
import Experience from '../Experience.js';
import ElementModelManager from "../../Data/DataManagers/ElementModelManager.js";

//https://en.wikipedia.org/wiki/Bounding_volume_hierarchy


let experience = null;
let manager = new ElementModelManager()


// Show the popup with a custom message
function showPopup(message) {
    console.log("show")
    document.getElementById('popup-message').textContent = message;
    document.getElementById('popup').classList.remove('hidden-popup');
}

// Hide the popup
function hidePopup() {
    document.getElementById('popup').classList.add('hidden-popup');
}

// Attach the close button functionality
document.getElementById('popup-close-button').addEventListener('click', hidePopup);

export function queryBVH(node, queryBox, results = []) {
    if (!node || !node.boundingBox.intersectsBox(queryBox))  return results;

    if (node.elements) {
        //console.log("add intersecting elements")
        // Leaf node, add intersecting elements
        results.push(...node.elements);
    } else {
        // Non-leaf node, query children
        //console.log("Non-leaf node, query children")
        node.children.forEach((child) => queryBVH(child, queryBox, results));
    }

    return results;
}

export async function meshBvhIndexer()
{

    console.log("index started")
    if (!experience) {
        experience = new Experience();
    }

    //let elements = manager.getModels();
    let elements = await ensureModelsReady(); // ✅ Wait until elements are populated

    //console.log("Original elements:", elements);

    // Clone the array to ensure it's fully resolved
    elements = [...elements]; 

    //console.log("Cloned elements before BVH:", elements);

    // Loop through each element and calculate its bounding box
    elements.forEach((element) => {
        //if (!element.mesh[0] || element.mesh[0].length === 0) return;
        if (!element.mesh || element.mesh.length === 0) return;
        //const mesh = element.mesh[0]; // Assuming the first mesh in the array
        const mesh = element.mesh; // Assuming the first mesh in the array
        const boundingBox = new THREE.Box3().setFromObject(mesh);

        // Store the bounding box in the element for future use
        element.boundingBox = boundingBox;
        //console.log(boundingBox);
    });

    const bvhRoot = buildBVH(elements);
    //console.log("bvhroot:", bvhRoot);

    experience.bvhRoot = bvhRoot;
    //printBVHTree(bvhRoot);
    console.log("bvh indexing finished!")
    //showPopup("Bounding Volume Hierarchy built");
    //console.log(elements)

}

async function ensureModelsReady() {
    return new Promise((resolve) => {
        const checkModels = () => {
            let elements = manager.getModels();
            //console.log("experience.elementcount")
            //console.log(experience.elementcount)
            if (elements.length > experience.elementcount) {
                experience.elementcount = elements.length;
                resolve(elements);
            } else {
                //console.warn("Waiting for models to be ready...");
                setTimeout(checkModels, 50); // Retry in 50ms
            }
        };
        checkModels();
    });
}


function buildBVH(elements) {
    // Base case: Create a leaf node if only one element remains
    if (elements.length === 1) {

            elements[0].bvhNode = {
            boundingBox: elements[0].boundingBox,
            elements: elements,
            children: []
            };
        return elements[0].bvhNode;
    }
    

    const enclosingBox = calculateBoundingBoxForGroup(elements);


    // Determine splitting axis (x, y, or z)
    const size = enclosingBox.getSize(new THREE.Vector3());
    const axis = size.x >= size.y && size.x >= size.z ? 'x' : (size.y >= size.z ? 'y' : 'z');

    // Sort elements along the splitting axis
    elements.sort((a, b) => a.boundingBox.min[axis] - b.boundingBox.min[axis]);
    //console.log("sorted elements:", elements)

    // Split elements into two groups
    const mid = Math.floor(elements.length / 2);

    if (mid === 0) { 
        console.error("Recursive call stuck! mid is 0");
        console.error("Elements: ", elements);
        return null;  // Prevent infinite recursion
    }
    const leftElements = elements.slice(0, mid);
    const rightElements = elements.slice(mid);

    // Recursively build child nodes
    const leftChild = buildBVH(leftElements);
    const rightChild = buildBVH(rightElements);

    return {
        boundingBox: enclosingBox,
        elements: null, // Non-leaf nodes don't store individual elements
        children: [leftChild, rightChild]
    };
}


function calculateBoundingBoxForGroup(elements) {

    const boundingBox = new THREE.Box3();

    elements.forEach((element) => {
        if (element.mesh) {
            // Compute the bounding box for each mesh and expand the overall bounding box
            const meshBoundingBox = new THREE.Box3().setFromObject(element.mesh);
            //const meshBoundingBox = new THREE.Box3().setFromObject(element.mesh[0]);
            boundingBox.union(meshBoundingBox);
        }
    });

    return boundingBox;
}


function printBVHTree(node, depth = 0) {
    console.log(`${' '.repeat(depth * 2)}Node at depth ${depth}:`);
    console.log("Bounding Box:", node.boundingBox);

    if (node.elements) {
        console.log("Leaf Node with elements:", node.elements);
    }

    if (node.children.length > 0) {
        console.log("Children:");
        node.children.forEach(child => printBVHTree(child, depth + 1));
    }
}


